import React from "react";

const NotFound: React.FC = () => {
  return <div className="text-4xl font-bold">Page not found</div>;
};

export default NotFound;
